

export default {
  components: {
  },
  props: {
    screen:{
      type: Object,
      default: () => {}
    },
  },
  data() {
    return {
      url: {
        WorkOrderInfoSumbit: SZH.assets.api + '/Custom/WorkOrderInfoSumbit',//工单回复
        GetWorkOrderForm: SZH.assets.api + '/Custom/GetWorkOrderForm',//获取表单信息
        GetWorkOrderList: SZH.assets.api + '/Custom/GetWorkOrderList',//获取回复列表
      },
      loading:true,
      form:{
        F_Id:'',
        F_Title:'',
        F_Content:'',
        F_Creator:'',
        F_CreateTimeStr:''
      },
      replay:{
        F_Message:'',
        F_OrderId:''
      },
      replayList:[],
      connection:null,
      hubProxy:null,
      canSend:false,
      DId:''
    }
  },
  methods: {
    goBack(){
      this.$router.go(-1)
    },
    connectServer() {
      var $this = this;
      var userCode = localStorage.getItem('UserCode');
      var userName = localStorage.getItem('UserName');
      var userId = localStorage.getItem('UserId');
      $this.connection = $.hubConnection(SZH.assets.ws, {});
      $this.hubProxy = $this.connection.createHubProxy("NoticeHub");
      $this.toGetMes();
      $this.connection.start().done((connection) => {
        // $this.sendMsg();
        // $this.ClientId = connection.id;
        $this.hubProxy.invoke('joinWorkOrderOnline', userCode,userId,$this.DId);
        // $this.toGetMes();
      }).fail((data) => {
      });
    },
    toGetMes() {
      var $this = this;
      $this.hubProxy.on("receiveWorkOrderMsg", (data) => {
        console.log(data);
        if(data){
          let obj = JSON.parse(data);
          $this.replayList.push(obj);

        }
      });
    },
    replyFun(){
      let self = this;
      if(!self.replay.F_Message){
        self.$message.error('请输入消息！');
        return
      }
      self.canSend = true;
      self.$http.post(self.url.WorkOrderInfoSumbit,self.replay)
        .then(result => {
          if (result.state == true) {
            self.replay.F_Message = '';
            self.$message.success('回复成功');
            self.getReplay();
            self.canSend = false;
          } else {
            self.canSend = false;
            self.$message.error(result.message);
          }

        }, () => {
          self.canSend = false;
          // 请求失败
          self.$message.error('登录失败，请检查您的网络是否可用。');
        });
    },

    onEdit(){
      let self = this;
      self.replay.F_Message = '';
      self.$http.post(self.url.GetWorkOrderForm,{
        keyValue:self.DId
      })
        .then(result => {
          if (result.state == true) {
            self.form.F_Id = result.data.F_Id;
            self.replay.F_OrderId = result.data.F_Id;
            self.form.F_Title = result.data.F_Title;
            self.form.F_Creator = result.data.F_Creator;
            self.form.F_CreateTimeStr = result.data.F_CreateTimeStr;
            self.form.F_Content = result.data.F_Content;

            self.getReplay()
          } else {
            self.form.F_Title = '';
            self.form.F_Content = '';
            self.$message.error(result.message);
          }
        }, () => {
          // 请求失败
          self.$message.error('登录失败，请检查您的网络是否可用。');
        });
    },
    getReplay(){
      let self = this;
      // self.meLoading = true;
      self.$http.post(self.url.GetWorkOrderList,{
        keyValue:self.form.F_Id
      })
        .then(result => {
          if (result.state == true) {
            self.replayList = result.data;
            // self.meLoading = false;
          } else {
            // self.meLoading = false;
            self.replayList = [];
            self.$message.error(result.message);
          }
        }, () => {
          // 请求失败
          // self.meLoading = false;
          self.$message.error('登录失败，请检查您的网络是否可用。');
        });
    },
    scrollToBottom() {
      const container = this.$refs.messageContainer;
      if (container) {
        container.scrollTop = container.scrollHeight;
      }
    },
  },
  computed: {

  },
  created() {

  },
  beforeDestroy(){
    if (this.connection) {
      try {
        this.connection.stop();
        console.log('SignalR连接已关闭');
      } catch (error) {
        console.error('关闭连接失败:', error);
      }
    }
  },
  mounted() {
    this.DId = this.$route.query.id;
    this.connectServer();
    this.onEdit();
  },
  watch: {
    replayList: {
      handler() {
        this.$nextTick(() => {
          this.scrollToBottom();
        });
      },
      deep: true
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/Notice/Notice.js